import * as React from 'react';
import * as styles from './client-tags.module.scss';
import SimpleOutlinedInput from '../../../common/simpleOutlinedInput';
import { IconButton, TableCell } from '@material-ui/core';
import { Delete, AddCircle } from '@material-ui/icons';
import IconButtonTooltip from '../../../common/iconButtonTooltip';
import clsx from 'clsx';
import ModalDialog from '../../../modal-dialog/modalDialog';
import UserModalContent from './userModalContent';
import useModal from '../../../../hooks/useModal';
import useTag from '../../../../hooks/useTag';
import Tag from '../../../../models/tag';
import Administrator from '../../../../models/administrator';
import { AssignedUser } from '../../../../models/client';
interface Props {
  tag: Tag;
  clientId: number;
  windowSize: number;
  clientUsers: AssignedUser[];
  clientAdministrators: Administrator[];
  fetchTagsHandler: () => void;
  deleteTagHandler: () => void;
  setSuccessMessage: (message: string) => void;
  setErrorMessage: (message: string) => void;
}

const TagTableItem = ({
  tag,
  clientId,
  windowSize,
  clientUsers,
  clientAdministrators,
  fetchTagsHandler,
  deleteTagHandler,
  setSuccessMessage,
  setErrorMessage
}: Props) => {
  const [tagInputValue, setTagInputValue] = React.useState<string>('');
  const [isTruncated, setIsTruncated] = React.useState<boolean>(false);
  const { modalIsOpen, openModal, closeModal } = useModal();
  const { updateTag } = useTag();

  const updateUsersHandler = (tag: Tag) => {
    updateTag(clientId, tag.tagId, tag)
      .then(response => {
        if (response.success) {
          setSuccessMessage(`Success: Updated tag ${response.message}: ${tag.name}`);
          fetchTagsHandler();
        } else {
          setErrorMessage(response.message);
        }
      })
      .catch(err => {
        setErrorMessage(err.responseJSON.message);
      });
    closeModal();
  };

  React.useEffect(() => {
    if (tag.name) {
      setTagInputValue(tag.name);
    }
  }, []);

  const handleNameSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    updateUsersHandler({ ...tag, name: tagInputValue });
  };
  // detect whether permissioned user text is truncated when window is resized
  const measuredRef = React.useCallback(
    node => {
      if (node !== null) {
        node.offsetHeight < node.scrollHeight ? setIsTruncated(true) : setIsTruncated(false);
      }
    },
    [windowSize]
  );
  return (
    <React.Fragment>
      <ModalDialog isOpen={modalIsOpen} onClose={closeModal} title={tag.name} width="650px">
        <UserModalContent
          tag={tag}
          clientUsers={clientUsers}
          clientAdministrators={clientAdministrators}
          updateUsersHandler={updateUsersHandler}
        />
      </ModalDialog>
      <TableCell className={styles.colorColumn}>
        <div className={styles.colorLabel} />
      </TableCell>
      <TableCell className={styles.nameColumn}>
        <form onSubmit={event => handleNameSubmit(event)}>
          <SimpleOutlinedInput
            label="Tag Name"
            value={tagInputValue}
            onChange={(event: any) => setTagInputValue(event.target.value)}
            onBlur={() => setTagInputValue(tag.name)}
          />
        </form>
      </TableCell>
      <TableCell className={styles.userCell}>
        <p
          ref={measuredRef}
          title={isTruncated ? `${tag.users}` : ''}
          className={clsx(isTruncated && styles.truncated)}
        >
          {tag.users}
        </p>
      </TableCell>
      <TableCell className={styles.actionsColumn}>
        <IconButtonTooltip title="Add Users">
          <IconButton onClick={openModal} size="small">
            <AddCircle style={{ color: '#006da8' }} />
          </IconButton>
        </IconButtonTooltip>
        <IconButtonTooltip title="Delete">
          <IconButton edge="end" onClick={deleteTagHandler} size="small">
            <Delete style={{ color: '#006da8' }} />
          </IconButton>
        </IconButtonTooltip>
      </TableCell>
    </React.Fragment>
  );
};

export default TagTableItem;
